type ErrorWithMessage <E> = E & {
  message: string
}

function isErrorWithMessage<E>(error: unknown): error is ErrorWithMessage<E> {
  return (
    typeof error === 'object'
    && error !== null
    && 'message' in error
    && typeof (error as Record<string, unknown>).message === 'string'
  );
}

function toErrorWithMessage<E>(maybeError: unknown): ErrorWithMessage<E> | Error {
  if (isErrorWithMessage<E>(maybeError)) return maybeError;

  try {
    return new Error(JSON.stringify(maybeError));
  } catch {
    return new Error(String(maybeError));
  }
}

export function getErrorMessage<E>(error: unknown) {
  return toErrorWithMessage<E>(error).message;
}

export function getFullErrorObject<E>(error: unknown) {
  return toErrorWithMessage<E>(error);
}
